import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const returnItemStyles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  returnItemTitleContainer: {
    height: '8.8vh',
  },
  returnItemTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: rem(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  returnItemTitleHeader: {
    color: themeColor.modalTitle,
  },
  returnItemContainer: {
    padding: 10,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '0vh',
  },
  fitHeight: {
    height: 'fit-content',
  },
  containerAlignment: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  buttonStyles: {
    height: '7.4369vh',
    width: '13.81vh',
    fontSize: rem(1.5),
    '@media (max-width: 1600px)': {
      fontSize: rem(1.2),
    },
    '@media (max-width: 1366px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1366px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.7),
    },
    '@media (max-width: 1280px)': {
      fontSize: rem(1),
    },
    '@media (max-width: 1024px)': {
      fontSize: rem(0.8),
    },
    '@media  (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    marginRight: '1.3280vh',
  },
  searchButtonStyles: {
    height: '7.4369vh',
    width: '13.81vh',
    fontSize: rem(1.5),
    '@media (max-width: 1600px)': {
      fontSize: rem(1.2),
    },
    '@media (max-width: 1366px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1366px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.7),
    },
    '@media (max-width: 1280px)': {
      fontSize: rem(1),
    },
    '@media (max-width: 1024px)': {
      fontSize: rem(0.8),
    },
    '@media  (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    marginRight: '1.3280vh',
    color: `${themeColor.white}!important`,
    backgroundColor: `${theme.palette.primary.main}!important`,
  },
  outerFlexDesgin: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  icon: {
    height: '5vh',
    width: '5vw',
    margin: 25,
  },
}));
